var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.stepNumber == 2 ? "block" : "hidden" }, [
    _c("h1", { staticClass: "registration-form-layout__title" }, [
      _vm._v(_vm._s(_vm.spFormTitle))
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "search-preferences-form registration-form-layout registration-form-layout--green flex"
      },
      [
        _c("p", { staticClass: "registration-form-layout__note" }, [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.locales &&
                  _vm.locales.subscription &&
                  _vm.locales.subscription.search_preferences
              )
            )
          ]),
          _vm._v(
            " " +
              _vm._s(
                _vm.locales &&
                  _vm.locales.subscription &&
                  _vm.locales.subscription.more_accurate_offers
              ) +
              " " +
              _vm._s(
                _vm.locales &&
                  _vm.locales.subscription &&
                  _vm.locales.subscription.you_can_skip
              )
          )
        ]),
        _vm._v(" "),
        _c("theme-location-dropdown", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "`required`"
            }
          ],
          attrs: {
            isRequired: true,
            name: "location_id[]",
            label: _vm.spCityTitle,
            placeholder:
              _vm.locales &&
              _vm.locales.subscription &&
              _vm.locales.subscription.add_location,
            endpoint: "/admin/autocomplete/locations"
          }
        }),
        _vm._v(" "),
        _c("theme-districts-dropdown", {
          attrs: {
            data: [],
            name: "districts[]",
            label: _vm.spDistrictTitle,
            placeholder: _vm.spDistrictPlaceholder,
            "district-input": true
          }
        }),
        _vm._v(" "),
        _c("theme-select", {
          attrs: {
            name: "distance",
            label: _vm.spDistanceTitle,
            value: _vm.spDistanceValue,
            options: _vm.spDistanceOptions
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-7"
          },
          [
            _c("theme-select", {
              attrs: {
                name: "property_type_id",
                label: _vm.spPropertyTypeTitle,
                value: _vm.spPropertyTypeValue,
                options: _vm.spPropertyTypeOptions,
                "zero-option": _vm.spNoPreference
              }
            }),
            _vm._v(" "),
            _c("theme-select", {
              attrs: {
                label: _vm.spBedroomsTitle,
                value: _vm.spBedroomsValue,
                name: "min_number_of_bedrooms",
                options: _vm.spBedroomsOptions
              }
            }),
            _vm._v(" "),
            _c("theme-select", {
              attrs: {
                label: _vm.spInteriorTitle,
                name: "furnishing_id",
                value: _vm.spInteriorValue,
                "zero-option": _vm.spNoPreference,
                options: _vm.spInteriorOptions
              }
            }),
            _vm._v(" "),
            _c("theme-select", {
              attrs: {
                name: "min_area",
                label: _vm.spSurfaceTitle,
                value: _vm.spSurfaceValue,
                options: _vm.spSurfaceOptions
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-7"
          },
          [
            _c("theme-checkboxes", {
              staticClass: "form__radio",
              attrs: {
                options: { "1": "Suitable for sharing (more tenants)" },
                name: "require_beeing_sharable",
                boldLabel: true
              }
            }),
            _vm._v(" "),
            _c("theme-checkboxes", {
              staticClass: "form__radio",
              attrs: {
                options: {
                  "1":
                    _vm.spParkingSpaceTitle +
                    " <div class='divider-vert'></div> <a class='hover:underline' target='_blank' href=" +
                    _vm.spParkingSpaceLink +
                    ">" +
                    _vm.spParkingSpaceLinkText +
                    " <span style='padding-left: 8px; font-size: 16px;' class='icon-external'></span></a>"
                },
                name: "require_parking",
                boldLabel: true
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "divider" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-7"
          },
          [
            _c("theme-select", {
              attrs: {
                name: "min_price",
                label: _vm.spRentalPriceFromTitle,
                value: _vm.spRentalPriceFromValue,
                options: _vm.spRentalPriceFromOptions
              }
            }),
            _vm._v(" "),
            _c("theme-select", {
              attrs: {
                name: "max_price",
                label: _vm.spRentalPriceToTitle,
                value: _vm.spRentalPriceToValue,
                options: _vm.spRentalPriceToOptions
              }
            }),
            _vm._v(" "),
            _c("theme-select", {
              attrs: {
                name: "rental_period_id",
                label: _vm.spRentPeriodTitle,
                value: _vm.spRentPeriodValue,
                "zero-option": _vm.spNoPreference,
                options: _vm.spRentPeriodOptions
              }
            }),
            _vm._v(" "),
            _c("theme-calendar", {
              attrs: {
                label: _vm.spStartDateRentTitle,
                name: "rental_starts_at",
                placeholder: _vm.spStartDateRentPlaceholder
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("theme-textarea", {
          attrs: {
            label: _vm.spExtraInformationTitle,
            name: "searchprofile_subscriber_note",
            rows: "6"
          }
        }),
        _vm._v(" "),
        _c("theme-checkboxes", {
          staticClass: "form__radio",
          attrs: {
            options: { "1": _vm.requestSrc },
            name: "request_src",
            additionalHtml: _vm.requestSrcInfo,
            bigLabel: true
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "theme-btn theme-btn--block theme-btn--primary",
            attrs: { id: "submitSearchPreferencesFormBtn", type: "submit" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.submitForm.apply(null, arguments)
              }
            }
          },
          [_vm._v("\n        " + _vm._s(_vm.commonSubmit) + "\n      ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c2b85b9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c2b85b9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/SearchPreferencesForm.vue
// module id = 650
// module chunks = 1